import classNames from "classnames";
import { Icon } from "../../icon/Icon";
import { IconType } from "../../icon/IconType";
import { IconSize } from "../../icon/IconSize";
import ReactDOM from "react-dom";
import { type MessageType } from "../Message";
import { IconClickable, IconClickableType } from "../../icon/IconClickable";
import { type ReactNode } from "react";
import classes from "./ToastMessage.module.less";

export interface MessageProps {
  children?: ReactNode;
  type: MessageType;
  className?: string;
  onClose?: () => void;
}

const ICONS = {
  warning: IconType.InformationCircle,
  error: IconType.ErrorCircle,
  info: IconType.InformationCircle,
  success: IconType.Check,
};

const ToastMessage = (props: MessageProps) => {
  const { type, children, onClose } = props;

  const cls = classNames(
    classes.message,
    { [classes.warn]: type === "warning" },
    { [classes.error]: type === "error" },
    { [classes.info]: type === "info" },
    props.className,
  );

  const message = (
    <div className={cls}>
      <div className={"container d-flex flex-align-start p-relative"}>
        <Icon type={ICONS[type]} className={classes.schaToastMessageIcon} size={IconSize.FONT_20} />
        <div className={classes.text}>{children}</div>
        <IconClickable
          className={classNames(classes.dismiss, !onClose && "v-hidden")}
          onIconClick={onClose}
          type={IconType.Close}
          size={IconSize.FONT_24}
          inverted={true}
          clickableType={IconClickableType.INFO}
        />
      </div>
    </div>
  );

  const container = document.getElementById("reactToastContainer");
  if (container) {
    return ReactDOM.createPortal(message, container);
  }
  return null;
};

export default ToastMessage;
